import { ApiParameter, get, post } from "@insite/client-framework/Services/ApiService";
import uniqueId from "@insite/mobius/utilities/uniqueId";
import { QuoteTerms } from "@tKgpco/Store/Data/Terms/TermsState";

const discrepnacyCollectionUrl = "/api/v2/discrepancy/GetDiscrepancyCollection";
const discrepancyDetailsUrl = "/api/v2/discrepancy/GetDiscrepancyDetails";
const updateDiscrepancyUrl = "/api/v2/discrepancy/UpdateUserChanges";
const discrepancyReportUrl = "/api/v2/report/GenerateDiscrepancyReport";

export interface DiscrepancyCollectionParam extends ApiParameter {
    discrepancyId?: string;
    poNumber?: string;
    status?: string[];
    fromDate?: string;
    toDate?: string;
    page?: number;
    pageSize?: number;
    defaultPageSize?: number;
    sort?: string;
    properties?: { [key: string]: string | number | boolean };
    isValid?: boolean;
    validationMessage?: string;
    uniqueId?: string;
}

export interface DiscrepancyReportParam extends ApiParameter {
    discrepancyId?: string;
    poNumber?: string;
    fromDate?: string;
    toDate?: string;
    status?: string;
}

export interface DiscrepancyCollectionResult {
    success: boolean;
    statusCode: number;
    discrepancyCollectionProperties: DiscrepancyCollectionProperty[];
    pagination: Pagination;
    uri: string;
    properties: Properties;
}

export interface DiscrepancyCollectionProperty {
    discrepancyNumber: string;
    date: string;
    orderTotal: string;
    orderTotalDisplay: string;
    unitPrice: string;
    status: string;
    poLineNumber: string;
    supplierPartNumber: string;
    customerPartNumber: string;
    poNumber: string;
    assignedTo: string;
}

export interface Pagination {
    currentPage: number;
    page: number;
    pageSize: number;
    defaultPageSize: number;
    totalItemCount: number;
    numberOfPages: number;
    pageSizeOptions: number[];
    sortOptions: any;
    sortType: any;
    nextPageUri: string;
    prevPageUri: string;
}

export interface Properties {}

export interface DiscrepancyDetailsParam extends ApiParameter {
    discrepancyId: string;
    uniqueId?: string;
}

export interface DiscrepancyDetailsResult {
    success: boolean;
    statusCode: number;
    discrepancyDetails: DiscrepancyDetails;
}

export interface DiscrepancyDetails {
    discrepancyNumber: string;
    poNumber: string;
    unitPrice: number;
    unitPriceDisplay: string;
    creator: string;
    planner: string;
    qtyOrdered: string;
    qtyShipped: string;
    qtyReceived: string;
    qtyDamaged: string;
    shipFromCity: string;
    shipFromState: string;
    dateShipped: string;
    dateReceived: string;
    dateCreated: string;
    dateClosed: any;
    custPartNumber: string;
    productTitle: any;
    mediumImagePath: any;
    supplierPartNumber: string;
    buyerCode: string;
    buyerRegion: string;
    buyerEmail: string;
    responsibility: string;
    failCode: string;
    csr: string;
    dcc: string;
    tcc: string;
    vendor: string;
    status: string;
    carrier: string;
    trackingNumber: string;
    shipFrom: string;
    plocShipTo: string;
    plocShipName: string;
    commentId: any;
    origination: any;
    userName: any;
    date: any;
    comment: any;
    discrepancyStatus: string;
    poLineNumber: string;
    brandName: string;
}

export interface UpdateDiscrepancyApiParameter {
    discrepancyId: string;
    discrepancyStatus: string;
    closedDate?: string;
}

export const getdiscrepancyCollection = async (parameters: DiscrepancyCollectionParam) => {
    const response = await get<DiscrepancyCollectionResult>(discrepnacyCollectionUrl, {
        ...parameters,
        uniqueId: uniqueId(),
    } as DiscrepancyCollectionParam);
    return response;
};

export const getdiscrepancyDetails = async (parameters: DiscrepancyDetailsParam) => {
    const response = await get<DiscrepancyDetailsResult>(discrepancyDetailsUrl, {
        ...parameters,
        uniqueId: uniqueId(),
    } as DiscrepancyDetailsParam);
    return response;
};

export const updateDiscrepancy = async (parameters: UpdateDiscrepancyApiParameter) => {
    const response = await post<UpdateDiscrepancyApiParameter>(updateDiscrepancyUrl, parameters);
    return response;
};

export const getDiscrepancyReport = async (parameters: DiscrepancyReportParam) => {
    const response = await get<any>(discrepancyReportUrl, parameters);
    return response;
};
